// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"127":"b141abedc8eb2483","2082":"8c05060a8f099175","2340":"c3c4f618fc5d0217"}[chunkId] + ".css";
};